import { init, reset, Identify, identify } from '@amplitude/analytics-browser';
import { z } from 'zod';

import type { ValidPropertyType } from '@amplitude/analytics-core/lib/esm/identify';

export const analysisUserPropertyKeys = {
  FACTORY_ID: 'factory_id',
  COGNITO_USERNAME: 'cognito_username',
  ES_DEVICE_ID: 'es_device_id',
  DESIGN_FLG: 'design_flg',
  DEBUG_MODE_ENABLED: 'debug_mode_enabled',
} as const;
const analysisUserPropertyKeys_Enum = z.enum([
  analysisUserPropertyKeys.FACTORY_ID,
  analysisUserPropertyKeys.COGNITO_USERNAME,
  analysisUserPropertyKeys.ES_DEVICE_ID,
  analysisUserPropertyKeys.DESIGN_FLG,
  analysisUserPropertyKeys.DEBUG_MODE_ENABLED,
]);
type AnalysisUserPropertyKeys = z.infer<typeof analysisUserPropertyKeys_Enum>;

export const isAnalysisEnabled = () => {
  if (typeof window === 'undefined') return false;

  const apiKey = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY || '';
  return apiKey !== '';
};

// ユーザーのプロパティをセットする
export const setAnalysisUserProperty = (
  key: AnalysisUserPropertyKeys,
  value: ValidPropertyType,
) => {
  if (!isAnalysisEnabled()) return;

  const identifyEvent = new Identify();
  identifyEvent.set(key, value);
  identify(identifyEvent);
};

export const resetAnalysisUser = () => {
  if (!isAnalysisEnabled()) return;

  reset();
};

// Amplitude SDK の設定
const initSDK = () => {
  if (isAnalysisEnabled()) {
    init(process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY || '', {
      autocapture: true,
      appVersion: process.env.NEXT_PUBLIC_APP_VERSION,
    });
  } else {
    // ブラウザでAPI_KEYがセットされていない時にのみエラーをコンソールに出力する
    if (typeof window !== 'undefined')
      console.error('Amplitude API Key is not set');
  }
};
initSDK();
